
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/miro-backup",
      function () {
        return require("private-next-pages/miro-backup.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/miro-backup"])
      });
    }
  